import React,{useEffect,useRef} from 'react'
import Bs from '@better-scroll/core'

export const Bscroll = (props) => {
    let { scrollY,scrollX ,bounce,momentum,startX} = props
    let wrapper = useRef();
    useEffect(() => {
        new Bs(wrapper.current,{
            scrollY : scrollY,
            scrollX : scrollX,
            click : true,
            bounce : {
                ...bounce
            },
            momentum,
            startX
        })
    },)

    return (
        <div style={{height : '100%'}} ref={wrapper}>
            {props.children}
        </div>
    )
}
